{
  "avatar": {
    "upload": "Profilkép feltöltése",
    "change": "Profilkép módosítása",
    "delete": "Profilkép törlése",
    "cropImage": "Kép vágása",
    "zoom": "Nagyítás",
    "uploadSuccess": "Profilkép sikeresen feltöltve",
    "uploadError": "Nem sikerült a profilkép feltöltése",
    "deleteSuccess": "Profilkép sikeresen törölve",
    "deleteError": "Nem sikerült a profilkép törlése",
    "invalidFile": "Érvénytelen fájltípus vagy méret",
    "fileReadError": "Nem sikerült a fájl olvasása"
  },
  "logo": {
    "prepareError": "Nem sikerült a logó feltöltésének előkészítése",
    "uploadSuccess": "Logó sikeresen feltöltve",
    "uploadError": "Nem sikerült a logó feltöltése",
    "deleteSuccess": "Logó sikeresen törölve",
    "deleteError": "Nem sikerült a logó törlése"
  }
}
